export default "__VITE_ASSET__fGTw8kzR__"